var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermanentFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166992 2.99944C0.166992 1.52701 1.3609 0.333374 2.83367 0.333374H8.16698C9.63975 0.333374 10.8337 1.52701 10.8337 2.99943V12.3312C10.8337 13.4532 9.5317 14.0733 8.66019 13.3663L5.92041 11.1436C5.67559 10.945 5.32509 10.945 5.08028 11.1436L2.34046 13.3663C1.46895 14.0733 0.166992 13.4532 0.166992 12.3312V2.99944ZM4.16701 4.99898C3.79882 4.99898 3.50034 5.29739 3.50034 5.66549C3.50034 6.0336 3.79882 6.33201 4.16701 6.33201H6.83368C7.20187 6.33201 7.50035 6.0336 7.50035 5.66549C7.50035 5.29739 7.20187 4.99898 6.83368 4.99898H4.16701Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermanentFolder);
export default __webpack_public_path__ + "static/media/permanentFolder.b3e5502f.svg";
export { ForwardRef as ReactComponent };